import MuiBreadcrumbs from '@mui/material/Breadcrumbs';
import MuiLink from '@mui/material/Link';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { designTokens } from '../../config/themes/design-tokens';

export const Root = styled(MuiBreadcrumbs)(({ theme }) => ({
  '& .MuiBreadcrumbs-separator': {
    margin: theme.spacing(0, 0.5),
    fontSize: designTokens.typography.fontSizes.body1,
    lineHeight: designTokens.typography.lineHeights.subtitle1,
    color: theme.palette.text.fourth,
    fontFamily: theme.typography.fontFamily,
  },
}));

export const CrumbLink = styled(MuiLink)(({ theme }) => ({
  cursor: 'pointer',
  textDecoration: 'none',
  fontSize: designTokens.typography.fontSizes.subtitle2,
  lineHeight: designTokens.typography.lineHeights.subtitle2,
  color: theme.palette.text.fourth,
  padding: theme.spacing(0.5),
  borderRadius: theme.customShape?.borderRadiusXSmall || '4px',
  transition: 'background-color 0.2s ease-in-out',
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
  '&:focus-visible': {
    outline: `2px solid ${theme.palette.primary.main}`,
    outlineOffset: '2px',
  },
}));

export const CrumbText = styled(Typography)(({ theme }) => ({
  fontSize: designTokens.typography.fontSizes.subtitle2,
  lineHeight: designTokens.typography.lineHeights.subtitle2,
  color: theme.palette.text.primary,
  padding: theme.spacing(0.5),
  borderRadius: theme.customShape?.borderRadiusXSmall || '4px',
}));
